import { Component } from '@angular/core';
import { AuthenticationStatus, LoginType, PageBaseComponent, UtilsString } from '@pit/core';
import { IPinItTrackFrontendApplicationService, IPinItTrackFrontendAuthenticationService, PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-login-password-reset',
    templateUrl: './pin.it.track.web.password.page.component.html',
    styleUrls: ['./pin.it.track.web.password.page.component.scss']
})
export class PinItTrackWebPasswordPageComponent extends PageBaseComponent {

    constructor(private readonly servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.authenticationService = this.servicesAccessor.coreServicesAccessor.authenticationService;
        this.applicationServiceExt = this.servicesAccessor.coreServicesAccessor.applicationService;

        this.loggingService.debug('PinItTrackWebPasswordPageComponent --> constructor()');
    }

    public readonly authenticationService: IPinItTrackFrontendAuthenticationService = null;

    public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

    public isBusy$: Observable<boolean> = this.servicesAccessor.coreServicesAccessor.applicationService.isBusy$;

    public get canLogin(): boolean {
        return ((UtilsString.stringIsNullOrEmpty(this.password1) === false) && (UtilsString.stringIsNullOrEmpty(this.password2) === false) && (this.password1 === this.password2));
    }

    public get isInLogin(): boolean {
        return ((this.authenticationService.authenticationStatus === AuthenticationStatus.InLoginCheckUser) ||
            (this.authenticationService.authenticationStatus === AuthenticationStatus.InLoginUserChecked) ||
            (this.authenticationService.authenticationStatus === AuthenticationStatus.InLoginCheckPassword) ||
            (this.authenticationService.authenticationStatus === AuthenticationStatus.InLoginPasswordChecked));
    }

    public password1: string = null;

    public password2: string = null;

    public async onInputKeyPressedAsync(event: any): Promise<void> {
        if ((event.keyCode === 13) && (this.canLogin === true)) {
            await this.loginAsync();
        }
    }

    public async loginAsync(): Promise<void> {
        if (this.canLogin === true) {
            this.servicesAccessor.eventService.sendEvent('auth', {
                type: 'login.password.reset',
                mandator: this.servicesAccessor.coreServicesAccessor.authenticationService.currentUser.mandator.code,
                password: this.password1
            });
        }
    }

}
